
// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import axiosInstance from "../../utils/axiosInstance";
// import "./worker.css";

// export default function WorkerAdd() {
//   const navigate = useNavigate();

//   const [sites, setSites] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState("");
//   const [success, setSuccess] = useState(false);

//   const [form, setForm] = useState({
//     workerName: "",
//     dailyWage: "",
//     gender: "",
//     workerType: "",
//     siteName: "",
//   });

//   // Fixed Worker Types
//   const workerTypes = ["Male Coolie", "Female Coolie", "Mistri"];

//   // Fetch sites
//   useEffect(() => {
//     const loadSites = async () => {
//       try {
//         const res = await axiosInstance.get("/show-AllProject");
//         setSites(Array.isArray(res.data) ? res.data : []);
//       } catch (err) {
//         setError("Failed to load sites.");
//       }
//     };
//     loadSites();
//   }, []);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setForm((prev) => ({ ...prev, [name]: value }));
//   };

//   const validate = () => {
//     if (!form.workerName.trim()) return "Worker name is required.";
//     if (!form.dailyWage || isNaN(form.dailyWage) || form.dailyWage <= 0)
//       return "Valid daily wage is required.";
//     if (!form.gender) return "Gender is required.";
//     if (!form.workerType) return "Worker type is required.";
//     if (!form.siteName) return "Site is required.";
//     return null;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     const err = validate();
//     if (err) {
//       setError(err);
//       return;
//     }

//     setLoading(true);
//     setError("");
//     setSuccess(false);

//     const payload = {
//       workerName: form.workerName.trim(),
//       dailyWage: parseFloat(form.dailyWage),
//       gender: form.gender,
//       workerType: form.workerType, // e.g., "Male Coolie"
//       siteName: form.siteName,
//     };

//     try {
//       await axiosInstance.post("/workers/add", payload);
//       setSuccess(true);
//       setTimeout(() => navigate("/worker"), 1500);
//     } catch (err) {
//       setError(err.response?.data?.message || "Failed to add worker.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="add-worker-page">
//       <div className="add-worker-card">
//         <div className="card-header-modern">
//           <h1>Add New Worker</h1>
//           <p>Enter worker details</p>
//         </div>

//         <div className="card-body-modern">
//           {success && (
//             <div className="alert success">Worker added! Redirecting...</div>
//           )}
//           {error && <div className="alert error">Error: {error}</div>}

//           <form onSubmit={handleSubmit} className="modern-form">
//             <div className="form-grid-2">
//               {/* Worker Name */}
//               <div className="input-group">
//                 <label>
//                   Worker Name <span className="required">*</span>
//                 </label>
//                 <input
//                   type="text"
//                   name="workerName"
//                   value={form.workerName}
//                   onChange={handleChange}
//                   placeholder="e.g. Bushan"
//                   required
//                 />
//               </div>

//               {/* Daily Wage */}
//               <div className="input-group">
//                 <label>
//                   Daily Wage (₹) <span className="required">*</span>
//                 </label>
//                 <input
//                   type="number"
//                   name="dailyWage"
//                   value={form.dailyWage}
//                   onChange={handleChange}
//                   placeholder="300"
//                   min="1"
//                   step="1"
//                   required
//                 />
//               </div>
//             </div>

//             <div className="form-grid-3">
//               {/* Gender */}
//               <div className="input-group">
//                 <label>
//                   Gender <span className="required">*</span>
//                 </label>
//                 <select
//                   name="gender"
//                   value={form.gender}
//                   onChange={handleChange}
//                   required
//                 >
//                   <option value="">Select</option>
//                   <option value="Male">Male</option>
//                   <option value="Female">Female</option>
//                   <option value="Other">Other</option>
//                 </select>
//               </div>

//               {/* Worker Type – FIXED OPTIONS */}
//               <div className="input-group">
//                 <label>
//                   Worker Type <span className="required">*</span>
//                 </label>
//                 <select
//                   name="workerType"
//                   value={form.workerType}
//                   onChange={handleChange}
//                   required
//                 >
//                   <option value="">Select Type</option>
//                   {workerTypes.map((type) => (
//                     <option key={type} value={type}>
//                       {type}
//                     </option>
//                   ))}
//                 </select>
//               </div>

//               {/* Site */}
//               <div className="input-group">
//                 <label>
//                   Site <span className="required">*</span>
//                 </label>
//                 <select
//                   name="siteName"
//                   value={form.siteName}
//                   onChange={handleChange}
//                   required
//                 >
//                   <option value="">Select Site</option>
//                   {sites.map((site) => (
//                     <option key={site.id} value={site.name}>
//                       {site.name}
//                     </option>
//                   ))}
//                 </select>
//               </div>
//             </div>

//             <div className="form-actions-modern">
//               <button
//                 type="button"
//                 onClick={() => navigate(-1)}
//                 className="btn-secondary"
//               >
//                 Cancel
//               </button>
//               <button
//                 type="submit"
//                 disabled={loading}
//                 className="btn-primary"
//               >
//                 {loading ? "Adding..." : "Add Worker"}
//               </button>
//             </div>
//           </form>
//         </div>
//       </div>
//     </div>
//   );
// }










import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../utils/axiosInstance";
import "./worker.css";

export default function WorkerAdd() {
  const navigate = useNavigate();

  const [sites, setSites] = useState([]);
  const [engineers, setEngineers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  const [form, setForm] = useState({
    workerName: "",
    dailyWage: "",
    gender: "",
    workerType: "",
    siteName: "",
    engineerName: "",
  });

  const workerTypes = ["Male Coolie", "Female Coolie", "Mistri"];

  // Fetch sites
  useEffect(() => {
    const loadSites = async () => {
      try {
        const res = await axiosInstance.get("/show-AllProject");
        setSites(Array.isArray(res.data) ? res.data : []);
      } catch (err) {
        setError("Failed to load sites.");
      }
    };
    loadSites();
  }, []);

  // Fetch engineers
  useEffect(() => {
    const loadEngineers = async () => {
      try {
        const res = await axiosInstance.get("/allEngineers");
        setEngineers(Array.isArray(res.data) ? res.data : []);
      } catch (err) {
        setError("Failed to load engineers.");
      }
    };
    loadEngineers();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const validate = () => {
    if (!form.workerName.trim()) return "Worker name is required.";
    if (!form.dailyWage || isNaN(form.dailyWage) || form.dailyWage <= 0)
      return "Valid daily wage is required.";
    if (!form.gender) return "Gender is required.";
    if (!form.workerType) return "Worker type is required.";
    if (!form.siteName) return "Site is required.";
    if (!form.engineerName) return "Engineer is required.";
    return null;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const err = validate();
    if (err) {
      setError(err);
      return;
    }

    setLoading(true);
    setError("");
    setSuccess(false);

    const payload = {
      workerName: form.workerName.trim(),
      dailyWage: parseFloat(form.dailyWage),
      gender: form.gender,
      workerType: form.workerType,
      siteName: form.siteName,
      engineerName: form.engineerName,
    };

    try {
      await axiosInstance.post("/workers/add", payload);
      setSuccess(true);
      setTimeout(() => navigate("/worker"), 1500);
    } catch (err) {
      setError(err.response?.data?.message || "Failed to add worker.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="add-worker-page">
      <div className="add-worker-card">
        <div className="card-header-modern">
          <h1>Add New Worker</h1>
          <p>Enter worker details</p>
        </div>

        <div className="card-body-modern">
          {success && (
            <div className="alert success">Worker added! Redirecting...</div>
          )}
          {error && <div className="alert error">Error: {error}</div>}

          <form onSubmit={handleSubmit} className="modern-form">
            <div className="form-grid-2">
              {/* Worker Name */}
              <div className="input-group">
                <label>
                  Worker Name <span className="required">*</span>
                </label>
                <input
                  type="text"
                  name="workerName"
                  value={form.workerName}
                  onChange={handleChange}
                  placeholder="e.g. Bushan"
                  required
                />
              </div>

              {/* Daily Wage */}
              <div className="input-group">
                <label>
                  Daily Wage (₹) <span className="required">*</span>
                </label>
                <input
                  type="number"
                  name="dailyWage"
                  value={form.dailyWage}
                  onChange={handleChange}
                  placeholder="300"
                  min="1"
                  step="1"
                  required
                />
              </div>
            </div>

            <div className="form-grid-3">
              {/* Gender */}
              <div className="input-group">
                <label>
                  Gender <span className="required">*</span>
                </label>
                <select
                  name="gender"
                  value={form.gender}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  <option value="Other">Other</option>
                </select>
              </div>

              {/* Worker Type */}
              <div className="input-group">
                <label>
                  Worker Type <span className="required">*</span>
                </label>
                <select
                  name="workerType"
                  value={form.workerType}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select Type</option>
                  {workerTypes.map((type) => (
                    <option key={type} value={type}>
                      {type}
                    </option>
                  ))}
                </select>
              </div>

              {/* Site */}
              <div className="input-group">
                <label>
                  Site <span className="required">*</span>
                </label>
                <select
                  name="siteName"
                  value={form.siteName}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select Site</option>
                  {sites.map((site) => (
                    <option key={site.id} value={site.name}>
                      {site.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            {/* Engineer — full width row */}
            <div className="input-group">
              <label>
                Engineer <span className="required">*</span>
              </label>
              <select
                name="engineerName"
                value={form.engineerName}
                onChange={handleChange}
                required
              >
                <option value="">Select Engineer</option>
                {engineers.map((eng) => (
                  <option
                    key={eng.id ?? eng.engineerId ?? eng.engineerName}
                    value={eng.engineerName ?? eng.name}
                  >
                    {eng.engineerName ?? eng.name}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-actions-modern">
              <button
                type="button"
                onClick={() => navigate(-1)}
                className="btn-secondary"
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={loading}
                className="btn-primary"
              >
                {loading ? "Adding..." : "Add Worker"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}